import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
import Enum from '@square/dashboard-utilities/utils/enum';
import { ItemDetails as ItemDetailsProto } from '@square/dashboard-protos/models/squareup/devicesettings/profiles/v2/model/settings/rtl/item_details';
export const VariationSelectionMethodType = new Enum(Object.keys(ItemDetailsProto.VariationSelectionMethod));
export default ProtoBaseModel.extend({
  variationSelectionMethod: attr(VariationSelectionMethodType)
});